import { Injectable } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';

@Injectable({
  providedIn: 'root'
})
export class OtService {

  constructor(public baseService: BaseService, public alertsService: AlertsService) { }

  getArguments(args) {
    if (Object.keys(args).length > 0) {
        var result = Object.keys(args).map(function (key) {
            return [key + ':' + args[key]];
        });

        var merged = [].concat.apply([], result);
        return merged.join()
    }
}

  checkDoctoroffScheduleExits(data): Promise<boolean> {  // check if doctor is off schedule for the selected booking time
    return new Promise((resolve) => {
      const args = "doctor_id:" + data.surgeon_id + ",serviceType_code:scheduling_detailing" + ",booking_date_time:" + data.expected_surgery_date_time;
      const request = this.baseService.get("CHECK_DOCTOR_OFF_SCHEDULE", args, "schedule_event_off", "facility-management");
      if (!request) {
        resolve(false);
        return;
      }
      request.subscribe(
        res => {
          if (res && res.resource && res.resource.length > 0 && res.resource[0].extra_data && res.resource[0].extra_data.is_off_schedule) {
            this.alertsService.error(res.resource[0].message);
            resolve(true)
          }
          else {
            resolve(false)
          }
        },
        err => {
          console.error("error in checking doctor off schedule :: ", err)
          resolve(false)
        })
    })
  }
}
